module.exports = __webpack_public_path__ + "img/building.45ce5e1e.png";